var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71777 6.35059C6.71777 6.43717 6.69954 6.51921 6.66309 6.59668C6.63118 6.6696 6.58333 6.73796 6.51953 6.80176L1.10547 12.0996C0.982422 12.2227 0.832031 12.2842 0.654297 12.2842C0.540365 12.2842 0.435547 12.2568 0.339844 12.2021C0.244141 12.1475 0.168945 12.0723 0.114258 11.9766C0.0595703 11.8854 0.0322266 11.7806 0.0322266 11.6621C0.0322266 11.4935 0.0914714 11.3454 0.209961 11.2178L5.18652 6.35059L0.209961 1.4834C0.0914714 1.35579 0.0322266 1.20768 0.0322266 1.03906C0.0322266 0.920573 0.0595703 0.815755 0.114258 0.724609C0.168945 0.628906 0.244141 0.553711 0.339844 0.499023C0.435547 0.444336 0.540365 0.416992 0.654297 0.416992C0.832031 0.416992 0.982422 0.476237 1.10547 0.594727L6.51953 5.89941C6.58333 5.96322 6.63118 6.03385 6.66309 6.11133C6.69954 6.18424 6.71777 6.264 6.71777 6.35059Z",
    fill: "#F1F8FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.1020bbc06d790693436d21b66137d6e2.svg";
export { ForwardRef as ReactComponent };